import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";

const AddInstagramForm = ({ onClose, refreshPosts }) => {
  const [instagramLink, setInstagramLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://server-gs.vercel.app/upload/main-instagram-post",
        { instagramLink }
      );
      
      Swal.fire({
        title: "Success!",
        text: "Instagram post added successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        refreshPosts();
        onClose();
      });
    } catch (error) {
      console.error("Error adding Instagram post:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to add Instagram post. Please check the link and try again.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Function to extract Instagram post ID from URL
  const getInstagramPostId = (url) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel)\/([^\/\?\&]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const postId = getInstagramPostId(instagramLink);

  return (
    <div >
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4">
          <div className="w-full">
            <label className="block text-md font-medium text-gray-900 mb-1">
              Instagram Post/Reel Link <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={instagramLink}
              onChange={(e) => setInstagramLink(e.target.value)}
              className="block w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              placeholder="https://www.instagram.com/p/... or https://www.instagram.com/reel/..."
              required
            />
            <p className="mt-1 text-sm text-gray-500">
              Paste the full URL of an Instagram post or reel
            </p>
          </div>

          {/* Preview */}
          {/* {postId && (
            <div className="mt-4">
              <h3 className="font-medium mb-2">Preview:</h3>
              <div className="flex justify-center">
                <iframe
                  src={`https://www.instagram.com/p/${postId}/embed`}
                  width="320"
                  height="400"
                  frameBorder="0"
                  scrolling="no"
                  allowtransparency="true"
                ></iframe>
              </div>
            </div>
          )} */}

          <div className="pt-4 w-full flex justify-start">
            <button
              type="submit"
              disabled={isLoading}
              className={`w-56 px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                isLoading ? "opacity-75 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? "Processing..." : "Add Instagram Post"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddInstagramForm;